import styled from '@emotion/styled';
import { Card, CardContent, Typography } from '@mui/material';
import Link from 'next/link';

const AvatarImage = styled.img`
  height: 64px;
  width: 77px;
  border-radius: 12px;
  object-fit: cover;
  object-position: center;
`;
const StyledTitle = styled(Typography)`
  display: flex;
  color: #000;
  font-family: var(--font-work-sans);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 137.8%; /* 22.048px */
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 5px;
`;
const StyledLink = styled(Link)`
  text-decoration: none;
`;
type MarkerCardProps = {
  title: string;
  imgSrc: string;
  experienceId: string;
};

const MarkerCard = ({ title, imgSrc, experienceId }: MarkerCardProps) => {
  return (
    <Card>
      <StyledLink href={`/experiences/${experienceId}/`}>
        <CardContent style={{ display: 'flex', flexDirection: 'row', padding: '5px' }}>
          <AvatarImage src={imgSrc} />
          <StyledTitle>{title}</StyledTitle>
        </CardContent>
      </StyledLink>
    </Card>
  );
};

export default MarkerCard;
